import type { MetaFunction } from 'react-router';
import type { loader } from '~/routes/_app.article.$article._index';
import type { Article } from 'schema-dts';
import { getMetaBaseUrl } from '../util/create-meta-base-url';
import type { StaticParentLoaders } from '../util';
import { buildImageObject } from '../util/build-image-object';

export const createArticleSchema: MetaFunction<
    typeof loader,
    StaticParentLoaders
> = (props) => {
    const { data, location } = props;
    if (!data) return [];
    const baseUrl = getMetaBaseUrl(props);

    const hasAuthor = data?.details.author.id;
    const authorName =
        data.details.author.name !== ''
            ? data.details.author.name
            : data.details.professional.Title;

    const bannerImage = buildImageObject(
        data.banner?.imageUrl ? baseUrl + data.banner.imageUrl : undefined,
        {
            caption: data.details?.title,
            creditText: data.details.professional.Title,
            creatorName: data.details.professional.Title,
            representativeOfPage: true,
        },
    );

    const articleSchema: Article = {
        '@type': 'Article',
        '@id': baseUrl + location.pathname,
        url: baseUrl + location.pathname,
        ...(bannerImage && { image: bannerImage }),
        headline: data.details?.title,
        name: data.details?.title,
        description: data.localisation?.Description ?? '',
        dateCreated: data.details.publishDate,
        datePublished: data.details.publishDate,
        dateModified: data.details.lastEditedDate,
        creator: authorName,
        author: {
            '@type': hasAuthor ? 'Person' : 'Organization',
            name: authorName,
        },
        wordCount: data.details.wordCount,
        publisher: {
            '@type': 'Organization',
            name: 'ArchiPro',
        },
    };

    return [articleSchema];
};
